module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RE5EY5/tc-custom/9781426805646.jpg?1716663322249",
      "alt": "This image is the cover for the book Compromised Lady"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Compromised Lady\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman forced to marry for her inheritance fears revealing her dark past to her prospective husband in this Regency romance.")]), _c('br'), _c('br'), _vm._v("As a girl she had been bubbling over with mischief."), _c('br'), _c('br'), _vm._v("As a woman she seemed half lost in shadow. But Richard Blakehurst couldn’t miss the flash of connection between them when his hand touched hers. It was as if he had awakened something deep inside her."), _c('br'), _c('br'), _vm._v("Seeing Richard again brought back the taunting memory of their dance at her coming-out ball. She must tame her wayward thoughts, because Thea doubted even her considerable fortune could buy Richard’s good opinion of her if ever he learnt the truth. . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Rolls\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Rolls lives in the Adelaide Hills of South Australia with her husband, two sons, several dogs and cats, and a number of chickens. She has a well-known love of tea and coffee, far too many books, and an overgrown garden. Currently Elizabeth is wondering if she should train the dogs to put her sons’ dishes in the dishwasher rather than continuing to ask the boys. She can be found on Facebook or readers are invited to contact her at books@elizabethrolls.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0